import { render, staticRenderFns } from "./PermissionFamille.vue?vue&type=template&id=fa01729a&scoped=true&"
import script from "./PermissionFamille.vue?vue&type=script&lang=js&"
export * from "./PermissionFamille.vue?vue&type=script&lang=js&"
import style0 from "./PermissionFamille.vue?vue&type=style&index=0&id=fa01729a&lang=scss&scoped=true&"
import style1 from "./PermissionFamille.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa01729a",
  null
  
)

export default component.exports